import { render, staticRenderFns } from "./EmailConfirmationModal.vue?vue&type=template&id=28b667b8&scoped=true&"
import script from "./EmailConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./EmailConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./EmailConfirmationModal.vue?vue&type=style&index=0&id=28b667b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b667b8",
  null
  
)

export default component.exports